import React, { useState } from "react";
import {
  Box,
  Button,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { KeyboardArrowDown, TaskAltOutlined } from "@mui/icons-material";
import { PrimaryButton } from "components/CustomComponents/DesignSystemButtons";
import { designColors, designShell } from "services/constants/designTokens";

// Shown between the toolbar and the table while rows are ticked — same
// look and place as Team Workspace Approvals' BulkApprovalBar. The bulk
// actions sit in one "Actions" dropdown (standard action menu look).
// actions: [{ label, icon, onClick, danger }]; danger items are red.
export const BulkSelectionBar = ({ selectedCount, onClear, actions }) => {
  const [anchor, setAnchor] = useState(null);
  if (!selectedCount) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1.5,
        px: 2,
        py: 1,
        mt: 1.5,
        backgroundColor: designColors.slate100,
        border: `1px solid ${designColors.slate200}`,
        borderRadius: 1,
      }}
    >
      <TaskAltOutlined sx={{ fontSize: 20, color: designColors.tealDark }} />
      <Typography sx={{ fontWeight: 600, color: designColors.slate800 }}>
        {selectedCount} record(s) selected
      </Typography>
      <Button
        onClick={onClear}
        sx={{ textTransform: "none", fontWeight: 600, color: designColors.tealDark }}
      >
        Clear selection
      </Button>
      <Box sx={{ flex: 1 }} />
      <PrimaryButton
        endIcon={<KeyboardArrowDown />}
        onClick={(event) => setAnchor(event.currentTarget)}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
      >
        Actions
      </PrimaryButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        elevation={0}
        PaperProps={{ sx: { ...designShell.actionMenuPaper, mt: 0.5 } }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.label}
            sx={{
              ...designShell.actionMenuItem,
              ...(action.danger ? { color: "#DC2626" } : {}),
            }}
            onClick={() => {
              setAnchor(null);
              action.onClick();
            }}
          >
            <ListItemIcon>
              <action.icon
                fontSize="small"
                sx={{ color: action.danger ? "#DC2626" : designColors.tealDark }}
              />
            </ListItemIcon>
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
